document.addEventListener('DOMContentLoaded', function(){
    document.addEventListener('scroll', checkScroll)

    function checkScroll(){
      const buttons = document.querySelector('.product-info__add-button');
      const button = document.querySelector('.mobile-button-m.product-info__add-button');
      const top_bar = document.querySelector('.cc-announcement');
      const header = document.querySelector('.cc-header')
      const image = document.querySelector('#product-media')

        const scroll_top = document.documentElement.scrollTop;
        if(scroll_top > buttons.offsetTop + top_bar.offsetHeight + header.offsetHeight + image.offsetHeight){
          button.classList.remove('div-hidden')
        }
        else{
          button.classList.add('div-hidden')
        }
      }

    checkScroll()
  })